import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/src/clients/tsrest/store/baseQuery'
import { generateTagTypesFromContract } from '@/src/clients/tsrest/store/tags'
import { generateEndpointsFromContract } from '@/src/clients/tsrest/store/endpoints'
import { MesaApi } from '@acre-rewards/lib'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyType = any

export type TSRestEndpoints = typeof Api.endpoints

export type TSRestApiPendingAction<T> = { type: `${string & T}/pending`; meta: AnyType }

export type TSRestApiFulfilledAction<T> = {
  type: `${string & T}/fulfilled`
  payload: AnyType
  meta: AnyType
}

export type TSRestApiRejectedAction<T> = {
  type: `${string & T}/rejected`
  error: AnyType
  meta: AnyType
}

export const Api = createApi({
  reducerPath: 'Api',
  baseQuery,
  tagTypes: generateTagTypesFromContract({ contract: MesaApi }),
  endpoints: (builder) =>
    generateEndpointsFromContract({
      builder,
      contract: MesaApi,
    }),
})
